module.exports = __webpack_public_path__ + "pstatic/img/upload_file.b141be58.png";